<script>
import DataProvider from './DataProvider.vue';
import MemberRepository from '../../js/repository/MemberRepository.js';

export default {
    components: {
        'kgr-data-provider': DataProvider,
    },
    props: {
        memberId: {
            type: Number,
            required: true,
        },
        callback: {
            type: Function,
            required: false,
            default: () => {},
        },
    },
    render(createElement) {
        return createElement(DataProvider, {
            props: {
                repository: MemberRepository.findDogRelations,
                params: [this.memberId],
                reload: this.load,
                callback: this.callback,
            },
            scopedSlots: this.$scopedSlots,
        });
    },
};
</script>
